import { Row, Col, Divider, AutoComplete, Table } from 'antd';
import { useEffect, useRef, useState } from 'react';
import StoricoService from 'services/storico';
import Loading from 'components/loading';
import _ from 'lodash';
import pdfIcon from 'assets/img/formats/pdf.png';
import Form from 'react-bootstrap/Form';
import { createRef } from 'react';
import axios from 'axios';
import Utils from '../../utils';

function StoriaUA({ isMobile }) {
  const [comuneOptions, setComuneOptions] = useState([]);
  const [comuneCodiceOptions, setComuneCodiceOptions] = useState([]);
  const [provinciaOptions, setProvinciaOptions] = useState([]);
  const [provinciaCodiceOptions, setProvinciaCodiceOptions] = useState([]);
  const [regioneOptions, setRegioneOptions] = useState([]);
  const [regioneCodiceOptions, setRegioneCodiceOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [denComune, setDenComune] = useState('');
  const [codComune, setCodComune] = useState('');
  const [selectedComune, setSelectedComune] = useState(null);
  const [denProvincia, setDenProvincia] = useState('');
  const [codProvincia, setCodProvincia] = useState('');
  const [selectedProvincia, setSelectedProvincia] = useState(null);
  const [denRegione, setDenRegione] = useState('');
  const [codRegione, setCodRegione] = useState('');
  const [selectedRegione, setSelectedRegione] = useState(null);
  const [selected, setSelected] = useState(false);
  const [riepilogoColumns, setRiepilogoColumns] = useState([]);
  const [riepilogoRows, setRiepilogoRows] = useState([]);
  const [dettaglioColumns, setDettaglioColumns] = useState([]);
  const [dettaglioRows, setDettaglioRows] = useState([]);
  const [datiVariazioneColumns, setDatiVariazioneColumns] = useState([]);
  const [datiVariazioneRows, setDatiVariazioneRows] = useState([]);
  const [descrizioneEvento, setDescrizioneEvento] = useState();
  const [selectedRow, setSelectedRow] = useState();
  const [title, setTitle] = useState();
  const [isBug, setIsBug] = useState(false);

  const uaType = {
    regione: "regione",
    provincia: "provincia",
    comune: "comune"
  };

  useEffect(() => {
    document.title = 'Storia unità territoriali - SITUAS';
  });

  const fetchComune = async (input, cancelToken) => {
    if (input?.length > 2) {
      setLoading(true);
      try {
        const { data } = await StoricoService.comune(input, cancelToken);
        setComuneOptions(
          data.items.map(({ comune: com, pro_com_t }, i) => ({
            label: `${com} - ${pro_com_t}`,
            //value: pro_com_t,
            value: i,
            denominazione: com,
            codice: pro_com_t,
            key: i
          }))
        );
        setLoading(false);
      } catch {
        setLoading(false);
      }
    }
  };

  const fetchCodiceComune = async (codice, cancelToken) => {
    if (codice?.length > 3) {
      setLoading(true);
      try {
        const { data } = await StoricoService.comuneCodice(codice, cancelToken);
        const sortedItems = data.items.sort((a, b) => {
          return a.pro_com_t < b.pro_com_t ? -1 : 1;
        });
        setComuneCodiceOptions(
          sortedItems.map(({ comune: co, pro_com_t }, i) => ({
            //label: `${pro_com_t} - ${co}`,
            //value: co,
            label: `${co} - ${pro_com_t}`,
            value: i,
            denominazione: co,
            codice: pro_com_t,
            key: i
          }))
        );
        setLoading(false);
      } catch {
        setLoading(false);
      }
    }
  };

  const fetchProvincia = async (input, cancelToken) => {
    if (input?.length > 2) {
      setLoading(true);
      try {
        const { data } = await StoricoService.provinceUts(input, cancelToken);
        setProvinciaOptions(
          data.items.map((obj, i) => ({
            label: `${obj['denominazione_uts']} - ${obj['cod_uts']} ${obj['descrizione tipo uts']}`,
            //value: obj['cod_uts'] + ':' + obj['tipo uts'],
            value: i,
            denominazione: obj['denominazione_uts'],
            codice: obj['cod_uts'],
            tipo: obj['tipo uts'],
            key: i
          }))
        );
        setLoading(false);
      } catch {
        setLoading(false);
      }
    }
  };
  const fetchTipo = async (input) => {
    const { data } = await StoricoService.provinceUtsCodice(input);
    let tipo = String(data.items[0]['tipo uts']);
    return tipo;
  };

  const fetchCodiceProvincia = async (codice, cancelToken) => {
    if (codice?.length > 1) {
      setLoading(true);
      try {
        const { data } = await StoricoService.provinceUtsCodice(codice, cancelToken);
        const sortedItems = data.items.sort((a, b) => {
          return a.cod_uts < b.cod_uts ? -1 : 1;
        });
        setProvinciaCodiceOptions(
          sortedItems.map((obj, i) => ({
            //label: `${obj['cod_uts']} - ${obj['denominazione_uts']} ${obj['descrizione tipo uts']}`,
            //value: obj['denominazione_uts'],
            label: `${obj['denominazione_uts']} - ${obj['cod_uts']} ${obj['descrizione tipo uts']}`,
            value: i,
            denominazione: obj['denominazione_uts'],
            codice: obj['cod_uts'],
            tipo: obj['tipo uts'],
            key: i
          }))
        );

        setLoading(false);
      } catch {
        setLoading(false);
      }
    }
  };

  const fetchRegione = async (input, cancelToken) => {
    if (input?.length > 2) {
      setLoading(true);
      try {
        const { data } = await StoricoService.regione(input, cancelToken);
        setRegioneOptions(
          data.items.map((obj, i) => ({
            label:
              obj['denominazione regione'] +
              ' - ' +
              obj['cod_regione'] +
              ' ' +
              obj['descrizione tipo regione'],
            //value: obj['cod_regione'] + '§' + obj['tipo regione'],
            value: i,
            codice: obj['cod_regione'],
            denominazione: obj['denominazione regione'],
            tipo: obj['tipo regione'],
            key: i
          }))
        );
        setLoading(false);
      } catch {
        setLoading(false);
      }
    }
  };

  const fetchCodiceRegione = async (codice, cancelToken) => {
    if (codice?.length > 0) {
      setLoading(true);
      try {
        const { data } = await StoricoService.regioneCodice(codice, cancelToken);
        const sortedItems = data.items.sort((a, b) => {
          return a.cod_regione < b.cod_regione ? -1 : 1;
        });
        setRegioneCodiceOptions(
          //data.items.map((obj, i) => ({
          //  label:
          //    obj['cod_regione'] +
          //    ' - ' +
          //    obj['denominazione regione'] +
          //    ' ' +
          //    obj['descrizione tipo regione'],
          //  value:
          //    obj['denominazione regione'] +
          //    '§' +
          //    obj['tipo regione'],
          //  key: i
          //}))
          sortedItems.map((obj, i) => ({
            //label:
            //  obj['denominazione regione'] +
            //  ' - ' +
            //  obj['cod_regione'] +
            //  ' ' +
            //  obj['descrizione tipo regione'],
            //value: obj['cod_regione'] + '§' + obj['tipo regione'],
            label:
              obj['denominazione regione'] +
              ' - ' +
              obj['cod_regione'] +
              ' ' +
              obj['descrizione tipo regione'],
            value: i,
            codice: obj['cod_regione'],
            denominazione: obj['denominazione regione'],
            tipo: obj['tipo regione'],
            key: i
          }))
        );
        setLoading(false);
      } catch {
        setLoading(false);
      }
    }
  };

  const handleClick = async () => {
    event.preventDefault();
    setDettaglioRows([]);
    setDettaglioColumns([]);
    setDatiVariazioneRows([]);
    setDatiVariazioneColumns([]);
    setSelectedRow();
    setDescrizioneEvento();
    if (selected) {
      if (selectedComune) {
        setLoading(true);

        const codiceComune = selectedComune.codice;
        let denominazioneComune = selectedComune.denominazione;

        setRiepilogoColumns([]);
        setRiepilogoRows([]);
        try {
          const { data } = await StoricoService.comuneRiepilogo(codiceComune, denominazioneComune);

          setTitle(denominazioneComune + ' - ' + codiceComune);
          const objectOrder = {
            variazione: null
          };
          const column = Object.assign(objectOrder, data.items[0]);
          const formattedColumns = Object.keys(
            _.omit(column, [
              'identificativo provvedimento',
              'codice comune corrente',
              'denominazione corrente',
              'descrizione evento',
              'id_comune_origine',
              'orderr',
              'data_inizio_amministrativa',
              'tipo variazione'
            ])
          ).map((key) => ({
            title: /*_.capitalize*/Utils.customCapitalize(key),
            dataIndex: key,
            key: key,
            onCell: () => ({
              style: { textAlign: 'left' }
            })
          }));
          const formattedRows = data.items.map((row, i) => {
            let rowObject = {
              key: row['id_comune_origine'] + '§' + row['identificativo provvedimento'] + '§' + i,
              id: i
            };
            Object.keys(
              _.omit(row, [
                'identificativo provvedimento',
                'codice comune corrente',
                'denominazione corrente',
                'id_comune_origine'
              ])
            ).forEach((value) => {
              rowObject = { ...rowObject, [value]: row[value], uaType: uaType.comune };
            });
            return rowObject;
          });
          setRiepilogoColumns(formattedColumns);
          setRiepilogoRows(formattedRows);
          setLoading(false);
        } catch {
          setLoading(false);
        }
      }

      if (selectedProvincia) {
        setLoading(true);
        const codiceProvincia = selectedProvincia.codice;
        let denominazioneProvincia = selectedProvincia.denominazione;
        const tipoProvincia = selectedProvincia.tipo;

        setRiepilogoColumns([]);
        setRiepilogoRows([]);
        try {
          const { data } = await StoricoService.provinceUtsRiepilogo(
            codiceProvincia,
            denominazioneProvincia,
            tipoProvincia
          );
          setTitle(denominazioneProvincia + ' - ' + codiceProvincia);
          const objectOrder = {
            variazione: null
          };
          const column = Object.assign(objectOrder, data.items[0]);
          const formattedColumns = Object.keys(
            _.omit(column, [
              'identificativo provvedimento',
              'descrizione evento',
              'codice uts corrente',
              'denominazione corrente',
              'id_uts',
              'tipo uts',
              'tipo variazione',
              'id_uts_origine'
            ])
          ).map((key) => ({
            title: /*_.capitalize*/Utils.customCapitalize(key),
            onCell: () => ({
              style: { textAlign: 'left' }
            }),
            dataIndex: key,
            key: key
          }));
          const formattedRows = data.items.map((row, i) => {
            let rowObject = {
              key:
                row['identificativo provvedimento'] +
                '§' +
                row['tipo uts'] +
                '§' +
                row['id_uts'] +
                '§' +
                row['tipo variazione'],
              id: i
            };
            Object.keys(_.omit(row, 'identificativo provvedimento')).forEach((value) => {
              rowObject = { ...rowObject, [value]: row[value], uaType: uaType.provincia };
            });
            return rowObject;
          });
          setRiepilogoColumns(formattedColumns);
          setRiepilogoRows(formattedRows);
          setLoading(false);
        } catch {
          setLoading(false);
        }
      }

      if (selectedRegione) {
        setLoading(true);

        const codiceReg = selectedRegione.codice;
        let denominazioneReg = selectedRegione.denominazione;
        const tipoRegione = selectedRegione.tipo;

        const lastIndex = denominazioneReg.lastIndexOf('-');
        if (denominazioneReg.split('-').length > 1) {
          if (lastIndex !== -1 && !denominazioneReg[lastIndex - 1].toLowerCase().match(/[a-z]/i)) {
            denominazioneReg = (
              denominazioneReg.substring(0, lastIndex) +
              '' +
              denominazioneReg.substring(lastIndex + 1)
            ).trim();
          }
        } else {
          if (!denominazioneReg[lastIndex - 1]?.toLowerCase()?.match(/[a-z]/i)) {
            denominazioneReg = denominazioneReg.replace('-', '').trim();
          }
        }

        setRiepilogoColumns([]);
        setRiepilogoRows([]);
        try {
          const { data } = await StoricoService.regioneRiepilogo(
            codiceReg,
            denominazioneReg,
            tipoRegione
          );
          setTitle(denominazioneReg + ' - ' + codiceReg);
          const objectOrder = {
            variazione: null
          };
          const columns = Object.assign(objectOrder, data.items[0]);
          const formattedColumns = Object.keys(
            _.omit(columns, [
              'identificativo provvedimento',
              'descrizione evento',
              'codice uts corrente',
              'denominazione corrente',
              'id_regione',
              'tipo reg',
              'tipo variazione',
              'id_regione_origine'
            ])
          ).map((key) => ({
            title: /*_.capitalize*/Utils.customCapitalize(key),
            dataIndex: key,
            key: key,
            onCell: () => ({
              style: { textAlign: 'left' }
            })
          }));
          const formattedRows = data.items.map((row, i) => {
            let rowObject = {
              key:
                row['identificativo provvedimento'] +
                '*' +
                row['data decorrenza'] +
                row['tipo variazione'],
              id: i
            };
            Object.keys(_.omit(row, 'identificativo provvedimento')).forEach((value) => {
              rowObject = { ...rowObject, [value]: row[value], uaType: uaType.regione };
            });
            return rowObject;
          });
          setRiepilogoColumns(formattedColumns);
          setRiepilogoRows(formattedRows);
          setLoading(false);
        } catch {
          setLoading(false);
        }
      }
    }
  };

  const handleRowClick = async (e) => {
    setLoading(true);
    setDescrizioneEvento(e['descrizione evento']);
    if (e.uaType === uaType.comune) {
      try {
        const { data } = await StoricoService.dettVariazioni(
          e['key'].split('§')[1],
          e['tipo variazione'],
          e['key'].split('§')[0]
        );

        const objectOrder = {
          variazione: null
        };
        const columns = Object.assign(objectOrder, data.items[0]);
        const formattedColumns = Object.keys(
          _.omit(columns, ['identificativo_provvedimento', 'tipo variazione'])
        ).map((key) => ({
          title: key !== 'url_pdf' ? /*_.capitalize*/Utils.customCapitalize(key) : 'PDF',
          dataIndex: key,
          key: key,
          onCell: () => ({
            style: { textAlign: 'left' }
          })
        }));

        const formattedRows = data.items.map((row) => {
          let rowObject = { key: JSON.stringify(row) };
          Object.values(_.omit(row, 'identificativo_provvedimento')).forEach((value, i) => {
            const isPdf =
              Object.keys(_.omit(data.items[0], 'identificativo_provvedimento'))[i] === 'url_pdf';
            rowObject = {
              ...rowObject,
              [Object.keys(_.omit(data.items[0], 'identificativo_provvedimento'))[i]]: isPdf ? (
                row['url_pdf'] ? (
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href={`${process.env.REACT_APP_API_URL_AZURE}/FileSituas/DOWNLOAD/PROVVEDIMENTO/${data.items[0]['identificativo_provvedimento']}.pdf`}>
                    <img
                      src={pdfIcon}
                      style={{ height: 'auto', width: '30px' }}
                      alt="pdf download"
                    />
                  </a>
                ) : (
                  '-'
                )
              ) : value?.length > 0 ? (
                value
              ) : (
                '-'
              )
            };
          });
          return rowObject;
        });
        setDettaglioColumns(formattedColumns);
        setDettaglioRows(formattedRows);
        setLoading(false);
      } catch {
        setLoading(false);
      }

      try {
        const { data } = await StoricoService.datiAssVariazioni(
          e['key'].split('§')[1],
          e['tipo variazione'],
          e['key'].split('§')[0]
        );
        const columns = data.items[0];
        const formattedColumns = Object.keys(
          _.omit(columns, ['variazione', 'tipo variazione'])
        ).map((key) => ({
          title: /*_.capitalize*/Utils.customCapitalize(key),
          dataIndex: key,
          key: key,
          onCell: () => ({
            style: { textAlign: 'left' }
          })
        }));

        const formattedRows = data.items.map((row) => {
          let rowObject = { key: JSON.stringify(row) };
          Object.keys(_.omit(row, [''])).forEach((value) => {
            rowObject = { ...rowObject, [value]: row[value] };
          });
          return rowObject;
        });
        setDatiVariazioneColumns(formattedColumns);
        setDatiVariazioneRows(formattedRows);
        setLoading(false);
      } catch {
        setLoading(false);
      }
    } else if (e.uaType === uaType.provincia) {
      try {
        const { data } = await StoricoService.dettVariazioniUts(
          e['tipo variazione'],
          e['key'].split('§')[0],
          //e['key'].split('§')[2],
          e['id_uts_origine'],
          e['key'].split('§')[1]
        );
        const objectOrder = {
          variazione: null
        };
        const column = Object.assign(objectOrder, data.items[0]);
        const formattedColumns = Object.keys(
          _.omit(column, ['identificativo_provvedimento', 'dt_prv_var', 'tipo variazione', 'id_uts_origine'])
        ).map((key) => ({
          title: key !== 'url_pdf' ? /*_.capitalize*/Utils.customCapitalize(key) : 'PDF',
          dataIndex: key,
          key: key,
          onCell: () => ({
            style: { textAlign: 'left' }
          })
        }));

        const formattedRows = data.items.map((row) => {
          let rowObject = { key: JSON.stringify(row) };
          Object.keys(_.omit(row, ['identificativo_provvedimento', 'dt_prv_var'])).forEach(
            (value) => {
              const isPdf = value === 'url_pdf';

              rowObject = {
                ...rowObject,
                [value]: isPdf ? (
                  row['url_pdf'] ? (
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href={`${process.env.REACT_APP_API_URL_AZURE}/FileSituas/DOWNLOAD/PROVVEDIMENTO/${data.items[0]['identificativo_provvedimento']}.pdf`}>
                      <img
                        src={pdfIcon}
                        style={{ height: 'auto', width: '30px' }}
                        alt="pdf download"
                      />
                    </a>
                  ) : (
                    '-'
                  )
                ) : row[value]?.length > 0 ? (
                  row[value]
                ) : (
                  '-'
                )
              };
            }
          );
          return rowObject;
        });
        setDettaglioColumns(formattedColumns);
        setDettaglioRows(formattedRows);
        setLoading(false);
      } catch {
        setLoading(false);
      }

      try {
        const { data } = await StoricoService.datiAssVariazioniUts(
          e['tipo variazione'],
          e['key'].split('§')[0],
          //e['key'].split('§')[2],
          e['id_uts_origine'],
          e['key'].split('§')[1]
        );
        const column = data.items[0];
        const formattedColumns = Object.keys(
          _.omit(column, ['tipo variazione', 'descrizione variazione'])
        ).map((key) => ({
          title: /*_.capitalize*/Utils.customCapitalize(key),
          dataIndex: key,
          key: key,
          onCell: () => ({
            style: { textAlign: 'left' }
          })
        }));

        const formattedRows = data.items.map((row) => {
          let rowObject = { key: JSON.stringify(row) };
          Object.keys(row).forEach((value) => {
            rowObject = { ...rowObject, [value]: row[value] };
          });
          return rowObject;
        });
        setDatiVariazioneColumns(formattedColumns);
        setDatiVariazioneRows(formattedRows);
        setLoading(false);
      } catch {
        setLoading(false);
      }
    } else if (e.uaType === uaType.regione) { // TODO!
      try {
        const { data } = await StoricoService.dettVariazioniRegione(
          e['tipo variazione'],
          e['tipo reg'],
          e['key'].split('*')[0],
          e['id_regione_origine']
        );
        const objectOrder = {
          variazione: null
        };
        const columns = Object.assign(objectOrder, data.items[0]);
        const formattedColumns = Object.keys(
          _.omit(columns, ['identificativo_provvedimento', 'dt_prv_var', 'tipo variazione', 'id_regione_origine'])
        ).map((key) => ({
          title: key !== 'url_pdf' ? /*_.capitalize*/Utils.customCapitalize(key) : 'PDF',
          dataIndex: key,
          key: key,
          onCell: () => ({
            style: { textAlign: 'left' }
          })
        }));

        const formattedRows = data.items.map((row) => {
          let rowObject = { key: JSON.stringify(row) };
          Object.keys(_.omit(row, ['identificativo_provvedimento', 'dt_prv_var'])).forEach(
            (value) => {
              const isPdf = value === 'url_pdf';
              rowObject = {
                ...rowObject,
                [value]: isPdf ? (
                  row['url_pdf'] ? (
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href={`${process.env.REACT_APP_API_URL_AZURE}/FileSituas/DOWNLOAD/PROVVEDIMENTO/${data.items[0]['identificativo_provvedimento']}.pdf`}>
                      <img
                        src={pdfIcon}
                        style={{ height: 'auto', width: '30px' }}
                        alt="pdf download"
                      />
                    </a>
                  ) : (
                    '-'
                  )
                ) : row[value]?.length > 0 ? (
                  row[value]
                ) : (
                  '-'
                )
              };
            }
          );
          return rowObject;
        });
        setDettaglioColumns(formattedColumns);
        setDettaglioRows(formattedRows);
        setLoading(false);
      } catch {
        setLoading(false);
      }

      try {
        const { data } = await StoricoService.datiAssVariazioniReg(
          e['tipo variazione'],
          e['tipo reg'],
          e['key'].split('*')[0],
          e['id_regione_origine']
        );

        const objectOrder = {
          'Codice Ripartizione': null,
          'Codice Compartimento/Regione': null,
          'Denominazione': null
        };
        const columns = Object.assign(objectOrder, data.items[0]);

        const formattedColumns = Object.keys(
          _.omit(columns, ['identificativo_provvedimento', 'dt_prv_var', 'descrizione variazione'])
        ).map((key) => ({
          title: key === 'CodCompRegAss' ? 'Codice Compartimento/Regione associato' : /*_.capitalize*/Utils.customCapitalize(key),
          dataIndex: key,
          key: key,
          onCell: () => ({
            style: { textAlign: 'left' }
          })
        }));

        const formattedRows = data.items.map((row) => {
          let rowObject = { key: JSON.stringify(row) };
          Object.keys(row).forEach((value) => {
            rowObject = {
              ...rowObject,
              [value]: row[value]
            };
          });
          return rowObject;
        });
        setDatiVariazioneColumns(formattedColumns);
        setDatiVariazioneRows(formattedRows);
        setLoading(false);
      } catch {
        setLoading(false);
      }
    } else {
      cleanComune();
      cleanProvincia();
      cleanRegione();
      setSelectedRow('');
      setRiepilogoRows([]);
      setDettaglioRows([]);
      setDatiVariazioneRows([]);
      setDettaglioColumns([]);
      setRiepilogoColumns([]);
      setDatiVariazioneColumns([]);
      setSelected(false);
      setDescrizioneEvento();
      setTitle();
      setComuneOptions([]);
      setComuneCodiceOptions([]);
      setProvinciaOptions([]);
      setProvinciaCodiceOptions([]);
      setRegioneOptions([]);
      setRegioneCodiceOptions([]);
      setLoading(false);
    }
  };

  const createSmartDebouncer = (fn, wait) => {
    let deb = _.debounce(fn, wait);
    let ret = useRef({
      fn: (input, cp) => {
        deb.cancel();
        if (ret.current.cancellationToken) {
          ret.current.cancellationToken.cancel();
        }

        ret.current.cancellationToken = axios.CancelToken.source();
        deb(input, ret.current.cancellationToken.token);
      },
      cancellationToken: null
    });

    return ret.current.fn;
  };

  const cleanRegione = () => {
    setDenRegione('');
    setCodRegione('');
    setSelectedRegione(null);
  };

  const cleanProvincia = () => {
    setDenProvincia('');
    setCodProvincia('');
    setSelectedProvincia(null);
  };

  const cleanComune = () => {
    setDenComune('');
    setCodComune('');
    setSelectedComune(null);
  };

  const debounceSearchComune = createSmartDebouncer(fetchComune, 700);
  const debounceSearchComuneCodice = createSmartDebouncer(fetchCodiceComune, 700);
  const debounceSearchProvincia = createSmartDebouncer(fetchProvincia, 700);
  const debounceSearchProvinciaCodice = createSmartDebouncer(fetchCodiceProvincia, 700);
  const debounceSearchRegione = createSmartDebouncer(fetchRegione, 700);
  const debounceSearchRegioneCodice = createSmartDebouncer(fetchCodiceRegione, 700);

  return (
    <Row className="box-3 storiaua">
      {loading && <Loading fullPage={true} />}

      <Col
        className={isMobile ? 'text-center' : ''}
        xs={{ span: 24, order: 2 }}
        lg={{ span: 9, order: 1 }}
        xl={{ span: 7, order: 1 }}>
        <form className="mt-5 pt-2 criteri" role="search">
          <div className="text-secondary">Scegli un criterio di ricerca</div>
          <Row className="criteri-row" gutter={15}>
            <Col span={18} className="criteri-interni">
              <label htmlFor="autocompleteregione">Compartimento/Regione</label>
              <AutoComplete
                tabIndex={0}
                dropdownClassName="storia-ua-denominazione"
                value={selectedRegione?.label || denRegione}
                options={regioneOptions}
                onChange={(e) => {
                  cleanRegione();
                  setDenRegione(e);
                  setSelected(false);
                }}
                onSelect={(_, o) => {
                  cleanComune();
                  cleanProvincia();
                  setSelectedRegione(o);
                  setSelected(true);
                }}
                onSearch={debounceSearchRegione}
                className="mb-3 input-w200"
                id="autocompleteregione"
                placeholder="Denominazione"
              />
            </Col>
            <Col span={6} className="criteri-interni">
              <label htmlFor="codice1">Codice</label>
              <AutoComplete
                tabIndex={0}
                id="codice1"
                dropdownClassName="storia-ua-codice"
                value={selectedRegione?.codice || codRegione?.split('§')[0]}
                options={regioneCodiceOptions}
                onChange={(e) => {
                  cleanRegione();
                  setCodRegione(e);
                  setSelected(false);
                }}
                onSelect={(_, o) => {
                  cleanComune();
                  cleanProvincia();
                  setSelectedRegione(o);
                  setSelected(true);
                }}
                onSearch={debounceSearchRegioneCodice}
                className="mb-3 input-w77"
                placeholder="Codice"
              />
            </Col>
          </Row>
          <Row className="criteri-row" gutter={15}>
            <Col span={18} className="criteri-interni">
              <label htmlFor="provinciatuts">Provincia/Uts</label>
              <AutoComplete
                tabIndex={0}
                id="provinciatuts"
                dropdownClassName="storia-ua-denominazione"
                value={selectedProvincia?.label || denProvincia}
                options={provinciaOptions}
                onChange={(value) => {
                  cleanProvincia();
                  setDenProvincia(value);
                  setSelected(false);
                }}
                onSelect={(_, o) => {
                  cleanComune();
                  cleanRegione();
                  setSelectedProvincia(o);
                  setSelected(true);
                }}
                onSearch={debounceSearchProvincia}
                className="mb-3 input-w200"
                placeholder="Denominazione"
              />
            </Col>
            <Col span={6} className="criteri-interni">
              <label htmlFor="codice2">Codice</label>
              <AutoComplete
                tabIndex={0}
                id="codice2"
                dropdownClassName="storia-ua-codice"
                value={selectedProvincia?.codice || codProvincia}
                options={provinciaCodiceOptions}
                onChange={(e) => {
                  cleanProvincia();
                  setCodProvincia(e);
                  setSelected(false);
                }}
                onSelect={(_, o) => {
                  cleanComune();
                  cleanRegione();
                  setSelectedProvincia(o);
                  setSelected(true);
                }}
                onSearch={debounceSearchProvinciaCodice}
                className="mb-3 input-w77"
                placeholder="Codice"
              />
            </Col>
          </Row>
          <Row className="criteri-row" gutter={15}>
            <Col span={18} className="criteri-interni">
              <label htmlFor="comune">Comune</label>
              <AutoComplete
                tabIndex={0}
                id="comune"
                dropdownClassName="storia-ua-denominazione"
                value={selectedComune?.label || denComune}
                options={comuneOptions}
                onChange={(value) => {
                  cleanComune();
                  setDenComune(value);
                  setSelected(false);
                }}
                onSelect={(_, o) => {
                  cleanRegione();
                  cleanProvincia();
                  setSelectedComune(o);
                  setSelected(true);
                }}
                onSearch={debounceSearchComune}
                className="mb-3 input-w200"
                placeholder="Denominazione"
              />
            </Col>
            <Col span={6} className="criteri-interni">
              <label htmlFor="codice3">Codice</label>
              <AutoComplete
                tabIndex={0}
                id="codice3"
                dropdownClassName="storia-ua-codice"
                value={selectedComune?.codice || codComune}
                options={comuneCodiceOptions}
                onChange={(e) => {
                  cleanComune();
                  setCodComune(e);
                  setSelected(false);
                }}
                onSelect={(_, o) => {
                  cleanRegione();
                  cleanProvincia();
                  setSelectedComune(o);
                  setSelected(true);
                }}
                onSearch={debounceSearchComuneCodice}
                className="mb-3 input-w77"
                placeholder="Codice"
              />
            </Col>
          </Row>

          <button
            tabIndex={0}
            type="submit"
            disabled={!selected}
            className="storia-ua-button mt-2"
            onClick={() => handleClick()}>
            Cerca
          </button>
          <button
            tabIndex={0}
            type="button"
            className="storia-ua-button mt-2 mb-5"
            onClick={() => {
              cleanComune();
              cleanProvincia();
              cleanRegione();
              setSelectedRow('');
              setRiepilogoRows([]);
              setDettaglioRows([]);
              setDatiVariazioneRows([]);
              setDettaglioColumns([]);
              setRiepilogoColumns([]);
              setDatiVariazioneColumns([]);
              setSelected(false);
              setDescrizioneEvento();
              setTitle();
              setComuneOptions([]);
              setComuneCodiceOptions([]);
              setProvinciaOptions([]);
              setProvinciaCodiceOptions([]);
              setRegioneOptions([]);
              setRegioneCodiceOptions([]);
            }}>
            Annulla
          </button>

          {descrizioneEvento && (
            <div>
              <div className="card p-2 descrizione">
                <span className="storia-ua-event-title">Descrizione evento:</span>
                <div> {descrizioneEvento} </div>
              </div>
              <div
                className={` ${
                  descrizioneEvento.length > 90 ? 'read-more-enabled' : 'read-more-disabled'
                }`}>
                <button
                  className="read-more storia-ua-button mt-2 mb-5"
                  type="button"
                  onClick={() => {
                    document.querySelector('.descrizione').classList.toggle('expanded');
                    document.querySelector('.read-more').textContent = document
                      .querySelector('.descrizione')
                      .classList.contains('expanded')
                      ? 'Leggi di meno'
                      : 'Leggi di più';
                  }}>
                  Leggi di più
                </button>
              </div>
            </div>
          )}
        </form>

        {isMobile && riepilogoRows.length > 0 && (
          <>
            {title && <div className="storia-ua-title">{title}</div>}
            <div className="storia-ua-header">Riepilogo variazioni</div>
            <Table
              scroll={{ x: 1000 }}
              bordered
              dataSource={riepilogoRows}
              columns={riepilogoColumns}
              pagination={false}
              rowClassName="storia-ua-rows"
              rowKey={(record) => record.id}
              onRow={(record) => {
                return {
                  tabIndex: 0,
                  onClick: () => handleRowClick(record),
                  onKeyDown: (event) => {
                    if (event.key === 'Enter') {
                      handleRowClick(record);
                    }
                  }
                };
              }}
            />
            {dettaglioRows.length > 0 && (
              <>
                <div className="storia-ua-header mt-5">Dettaglio provvedimento</div>
                <Table
                  scroll={{ x: 1000 }}
                  bordered
                  dataSource={dettaglioRows}
                  columns={dettaglioColumns}
                  pagination={false}
                />
              </>
            )}
            {datiVariazioneRows.length > 0 && (
              <>
                <div className="storia-ua-header mt-5">Dettaglio variazione</div>
                <Table
                  scroll={{ x: 1000 }}
                  bordered
                  dataSource={datiVariazioneRows}
                  columns={datiVariazioneColumns}
                  pagination={false}
                />
              </>
            )}
          </>
        )}
      </Col>
      <Col
        xs={{ span: 23, order: 1 }}
        lg={{ span: 14, order: 2 }}
        xl={{ span: 16, order: 2 }}
        offset={1}>
        <h2 className="title-main">Storia unità territoriali</h2>
        <Divider className="blue-divider" />

        {!riepilogoRows.length > 0 && (
          <div>
            Dopo aver ricercato la denominazione/codice dell'unità di interesse il sistema restituisce il riepilogo delle variazioni. <br/>Selezionata una variazione sono mostrati estremi e dettagli del provvedimento e unità coinvolte.
          </div>
        )}
        {!isMobile && riepilogoRows.length > 0 && (
          <>
            {title && <div className="storia-ua-title">{title}</div>}

            <div className="storia-ua-header">Riepilogo variazioni</div>
            <Table
              scroll={{ x: 500 }}
              bordered
              dataSource={riepilogoRows}
              columns={riepilogoColumns}
              pagination={false}
              rowKey={(record) => record.id}
              rowClassName={(_, index) => {
                return index === selectedRow ? 'storia-ua-rows selected storia-ua-rows' : 'storia-ua-rows storia-ua-rows';
              }}
              onRow={(record, index) => {
                return {
                  tabIndex: 0,
                  onClick: () => {
                    handleRowClick(record);
                    setSelectedRow(index);
                  },
                  onKeyDown: (event) => {
                    if (event.key === 'Enter') {
                      handleRowClick(record);
                    }
                  }
                };
              }}
            />

            {dettaglioRows.length > 0 && (
              <>
                <div className="storia-ua-header mt-5">Dettaglio provvedimento</div>
                <Table
                  scroll={{ x: 500 }}
                  bordered
                  dataSource={dettaglioRows}
                  columns={dettaglioColumns}
                  pagination={false}
                />
              </>
            )}

            {datiVariazioneRows.length > 0 && (
              <>
                <div className="storia-ua-header mt-5">Dettaglio variazione</div>
                <Table
                  className="mb-5"
                  scroll={{ x: 500 }}
                  bordered
                  dataSource={datiVariazioneRows}
                  columns={datiVariazioneColumns}
                  pagination={false}
                />
              </>
            )}
          </>
        )}
      </Col>
    </Row>
  );
}
export default StoriaUA;
